<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div v-if="item">
        <div class="header">
            <h3>{{ $t('dispatch.dispatch') }}</h3>
        </div>
        <div>
            <!-- Status -->
            <div class="m-2 p-3 stat-container text-center">
                <span style="color: #438c0a; font-size: 3em; font-weight: 300">{{ getStatus(item)}}%</span>
            </div>
            <!-- TODO - Show order geometry on the map and allow trip fetching and simulating -->

            <!-- Basic  -->
            <h4 class="form-header pl-3 pr-4" style="color: #0b4b8f">{{ $t('contracts.basic_info')}}</h4>
            <div class="row pb-1">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t("contract_reports.contract") }}</span>
                    <span>{{ item.work_order.contract.name }}</span>
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t("contract_reports.order") }}</span>
                    <span>{{ item.work_order.task_type.name }} {{ item.work_order.info ? '(' + item.work_order.info + ')' : '' }}</span>
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t("dispatch.dispatcher") }}</span>
                    <span>{{ item.created_by.first_name }} ({{ item.created_by.last_name }})</span>
                </div>
            </div>
            <div class="row pb-1">
                <div class="col-sm-4">
                    <span class="span-title">{{ $t("work_assignment.created_by") }}</span>
                    <span>{{ toLocalTime(item.created) }}</span>
                </div>
                <div class="col-sm-4">
                    <span class="span-title">{{ $t("dispatch.deadline") }}</span>
                    <span>{{ toLocalTime(item.deadline) }}</span>
                </div>
                <div class="col-sm-4" :class="{'danger-container' : isDelayed(item)}">
                    <span class="span-title" :class="{'text-danger' : isDelayed(item)}">{{ $t("dispatch.completed") }}</span>
                    <span :class="{'text-danger' : isDelayed(item)}">{{ getCompletionTime(item) }}</span>
                </div>
            </div>
            <!-- Work assignments -->
            <h4 class="form-header pl-3 pr-4" style="color: #0b4b8f">{{ $t('menu.work_assignment')}}</h4>
            <work-assignment-list :results="item.work_assignments"/>
            <!-- Trips on the map -->
            <h4 class="form-header pl-3 pr-4" style="color: #0b4b8f">{{ $t('work_report.trips')}}</h4>
            <dispatch-trips :dispatch="item"/>
        </div>

        <div class="col-12 text-right">
            <button
                class="btn btn-secondary form-button"
                @click="$emit('close')"
            >
                {{ $t('common.close') }}
            </button>
        </div>
    </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {dispatchHelper} from "@/components/mixins/DispatchMixin";
import WorkAssignmentList from "@/components/workassignment/WorkAssignmentList";
import DispatchTrips from "@/components/dispatch/DispatchTrips";

export default {
    name: 'DispatchDetails',
    components: {DispatchTrips, WorkAssignmentList},
    mixins: [timeUtils, dispatchHelper],
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>
<style>
.danger-container {
    border: 1px solid #de8b8b;
    border-radius: .5em;
    padding-bottom: .1em;
    background-color: #fae7e7;
}

</style>
